export const MINIMAL_SEARCH_LENGTH = 3;

export const ArrangeListType = {
  ENUM: 'enum',
  STRING: 'string',
};
